import { Box, Divider, Typography } from "@mui/material";
import { LanguageContext } from "common/contexts/LanguageContext";
import React, { FC, useContext } from "react";

const LayoutHeader: FC = () => {
  const { getString } = useContext(LanguageContext);

  return (
    <>
      <Typography variant="h5" component="div">
        <Box sx={{ textTransform: "uppercase", fontWeight: "bold" }}>{getString("wlcm_title")}</Box>
      </Typography>
      <div style={{ paddingTop: "20px", paddingBottom: "20px" }}>
        <Typography variant="body1">{getString("wlcm_anonymousbody1")}</Typography>
        <Typography variant="body1">{getString("wlcm_anonymousbody2")}</Typography>
      </div>
      <Divider
        sx={{
          borderColor: "gray",
          width: "100%",
          borderBottomWidth: "2px",
          mb: "10px",
        }}
      />
    </>
  );
};

export default LayoutHeader;
